export const VALID_BLIND_RAISES = [20, 40, 60, 100, 200, 300, 400, 800, 1600]
